import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


// Seleziona gli elementi SVG
const elements = document.querySelectorAll('.parallax-elements--right .parallax-elements__item');

// Applica un'animazione di parallasse a ciascun elemento
elements.forEach((element, index) => {
    const scrubValue = 2.8 + index * 1.5;  // Incrementa il valore di `scrub` per ogni elemento

    gsap.fromTo(element, 
      { y: 0 }, // Posizione iniziale (modificabile a seconda dell'effetto desiderato)
      {
        y: -100, // Posizione finale
        scrollTrigger: {
          trigger: element,
          start: "top bottom", // Quando l'elemento entra nella viewport
          end: "bottom top", // Quando l'elemento esce dalla viewport
          scrub: scrubValue,
          markers: false, // Mostra i marker di debug (rimuovili in produzione)
          toggleActions: "restart pause reverse pause"
        }
      }
    );
});



// Seleziona gli elementi SVG
const elements_left = document.querySelectorAll('.parallax-elements--left .parallax-elements__item');

// Applica un'animazione di parallasse a ciascun elemento
elements_left.forEach((element, index) => {
    const scrubValue = 3.5 + index * 1.5;  // Incrementa il valore di `scrub` per ogni elemento

    gsap.fromTo(element, 
      { y: 0 }, // Posizione iniziale (modificabile a seconda dell'effetto desiderato)
      {
        y: 100, // Posizione finale
        scrollTrigger: {
          trigger: element,
          start: "top bottom", // Quando l'elemento entra nella viewport
          end: "bottom top", // Quando l'elemento esce dalla viewport
          scrub: scrubValue,
          markers: false, // Mostra i marker di debug (rimuovili in produzione)
          toggleActions: "restart pause reverse pause"
        }
      }
    );
});
